module.exports = __webpack_public_path__ + "public/img/responseTime.bc9a232f.png";